<template>
  <v-card outlined>
    <v-card-title>
      Outras Receitas
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="openDialog()">
        <v-icon left>mdi-plus-circle-outline</v-icon> Adicionar
      </v-btn>
    </v-card-title>
    <v-card-subtitle>
      Fontes de receita adicionais. Os valores serão integrados ao motor de cálculo numa etapa futura.
    </v-card-subtitle>
    <v-data-table
      :headers="headers"
      :items="items"
      no-data-text="Nenhuma receita adicional cadastrada"
      :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
    >
      <template v-slot:item.valorVenda="{ item }">{{ item.valorVenda | price }}</template>
      <template v-slot:item.custoUnitario="{ item }">{{ item.custoUnitario | price }}</template>
      <template v-slot:item.inadimplencia="{ item }">{{ item.inadimplencia }} %</template>
      <template v-slot:item.reajusteAnual="{ item }">{{ item.reajusteAnual }} %</template>
      <template v-slot:item.ativo="{ item }">
        <v-simple-checkbox v-model="item.ativo" disabled></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn color="error" fab text small @click="remove(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>Nova receita</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-text-field label="Descrição" v-model="form.descricao" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field label="Quantidade" v-model.number="form.quantidade" type="number" min="0" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="6">
              <decimal-number label="Valor de venda" v-model="form.valorVenda" outlined dense></decimal-number>
            </v-col>
            <v-col cols="6">
              <decimal-number label="Custo unitário" v-model="form.custoUnitario" outlined dense></decimal-number>
            </v-col>
            <v-col cols="6">
              <v-text-field label="Inadimplência %" v-model.number="form.inadimplencia" type="number" step="0.1" min="0" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field label="Reajuste anual %" v-model.number="form.reajusteAnual" type="number" step="0.1" min="0" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="6" class="d-flex align-center">
              <v-switch v-model="form.ativo" label="Ativo" hide-details class="mt-0"></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="save">Adicionar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import DecimalNumber from '@/components/DecimalNumber'

function emptyForm () {
  return {
    descricao: '',
    quantidade: 0,
    valorVenda: 0,
    custoUnitario: 0,
    inadimplencia: 0,
    reajusteAnual: 0,
    ativo: true
  }
}

export default {
  name: 'TabOutrasReceitas',
  components: { DecimalNumber },
  props: {
    items: { type: Array, default: () => [] }
  },
  data: () => ({
    dialog: false,
    form: emptyForm(),
    headers: [
      { text: 'Descrição', value: 'descricao' },
      { text: 'Quantidade', value: 'quantidade' },
      { text: 'Valor de venda', value: 'valorVenda' },
      { text: 'Custo unitário', value: 'custoUnitario' },
      { text: 'Inadimplência', value: 'inadimplencia' },
      { text: 'Reajuste anual', value: 'reajusteAnual' },
      { text: 'Ativo', value: 'ativo', sortable: false },
      { text: '', value: 'actions', sortable: false }
    ]
  }),
  methods: {
    openDialog () {
      this.form = emptyForm()
      this.dialog = true
    },
    save () {
      this.$emit('update', [...this.items, { ...this.form }])
      this.dialog = false
    },
    remove (item) {
      this.$emit('update', this.items.filter(i => i !== item))
    }
  }
}
</script>
